<div class="flex flex-row container justify-center items-start content-start">
  <div class="basis-2/5 wrapper">
    <span class="close" role="button" tabindex="0" aria-label="Sluiten" (click)="close()" (keydown.enter)="close()"><mat-icon aria-hidden="true">close</mat-icon></span>
    <div class="justify-center items-center text-center">
      <img src="assets/images/logo-img.svg" alt="BeeFund" class="mx-auto"/>
      <h1 mat-dialog-title>{{ 'Wijzig wachtwoord' | translate }}</h1>
      <p>{{ 'Voer een nieuw wachtwoord in' | translate }}</p>
    </div>
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" autocomplete="on">
      <div class="flex flex-col">
        <mat-form-field appearance="fill" floatLabel="auto">
          <mat-label>{{ 'Wachtwoord' | translate }}</mat-label>
          <input type="password" name="password" matInput [placeholder]="'Wachtwoord'|translate" formControlName="password" id="password" autocomplete="new-password" minlength="6" required>
          <mat-error>
            <div *ngIf="password.invalid && password.errors.required">{{ 'Voer een wachtwoord in.' | translate }}</div>
            <div *ngIf="password.invalid && !password.errors.required && password.errors.minlength">{{ 'Wachtwoord moet minimaal 6 karakters bevatten' | translate }}</div>
            <div *ngIf="password.invalid && !password.errors.required && !password.errors.minlength && password.errors.pattern">{{ 'Wachtwoord moet een letter en getal bevatten' | translate }}</div>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" floatLabel="auto">
          <mat-label>{{ 'Bevestig wachtwoord' | translate }}</mat-label>
          <input type="password" name="confirmPassword" matInput [placeholder]="'Bevestig wachtwoord'|translate" formControlName="confirmPassword" id="confirmPassword" autocomplete="new-password" minlength="6" required>
          <mat-error>
            <div *ngIf="confirmPassword.invalid && confirmPassword.errors.required">{{ 'Voer wachtwoord bevestiging in' | translate }}</div>
            <div *ngIf="confirmPassword.invalid && !confirmPassword.errors.required && confirmPassword.errors.notMatch">{{ 'Wachtwoorden komen niet overeen' | translate }}</div>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-col justify-center items-center content-center mr-2">
        <button mat-raised-button type="submit" color="accent" [disabled]="changePasswordForm.invalid">{{'Verander wachtwoord'|translate}}</button>
      </div>
    </form>
  </div>
</div>
